import { PaymentMethodDTO, PaymentMethodType } from "@gymflow/types";

export const paymentMethodHelper = {
  isBankPaymentMethod(paymentMethod: PaymentMethodDTO) {
    return (
      [
        "UK_DIRECT_DEBIT",
        "US_DIRECT_DEBIT",
        "AU_DIRECT_DEBIT",
        "CA_DIRECT_DEBIT",
        "EU_DIRECT_DEBIT",
      ] as PaymentMethodType[]
    ).includes(paymentMethod.type);
  },
};
